import questionReader from '../../store/readHelpers/QuestionReader';
import assessmentReader from '../../store/readHelpers/AssessmentReader';
import hardwareDetectionService from '../../services/HardwareDetectionService';
import uiReader from '../../store/readHelpers/uiReader';

const modalsContainerSelector = {
    selectShouldRenderOneWayNavigationModals(questionId) {
        const question = assessmentReader.getQuestion(questionId);
        return questionReader.shouldCommitAnswerTimestamp(question);
    },

    selectShouldRenderSecondScreenDetectedModal() {
        return hardwareDetectionService.isAdditionalScreenDetectionRequired() && uiReader.wasScreenExtended();
    },

    selectProps(state) {
        const { currentlyShown } = state;

        return {
            shouldRenderOneWayNavigationModals: this.selectShouldRenderOneWayNavigationModals(currentlyShown.questionId),
            shouldRenderSecondScreenDetectedModal: this.selectShouldRenderSecondScreenDetectedModal(),
        };
    },
};

export default modalsContainerSelector;
